import { useEffect, useState } from "react";
import { dispatch, useDispatch, useSelector } from "react-redux";
import { addCategory, deleteCategory } from "../store/action";
import { fetchItems, fetchCategories } from "../store/action";
import CategoriesEdit from "./CategoriesEdit";
import CategoriesTableRow from "./CategoriesTableRow";

function CategoriesTable() {
  const dispatch = useDispatch()
  const categories = useSelector((state) => state.categoryReducer.categories)
  const [categoryInput, setCategoryInput] = useState('')

  useEffect(() => {
    dispatch(fetchItems())
    dispatch(fetchCategories())
}, []);

  const handleChange = (e) => {
    const name = e.target.value;
    setCategoryInput(name)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(addCategory(categoryInput))
    setCategoryInput('')
  }
  
  return (
    <div className="px-3 py-5">
      <h1 className="mb-5">Category List</h1>

      <button className="btn btn-primary mb-3" type="button" data-toggle="collapse" data-target="#formCategory">
        + Create Category
      </button>
      <div className="collapse" id="formCategory">
        <div className="card card-body">
          <form>
            <div className="form-group">
              <div className="row">
                <div className="col">
                <label>Category Name</label>
                </div>
                <div className="col">
                <input onChange={handleChange} value={categoryInput} name="name" type="text" className="form-control"/>
                </div>
                <div className="col">
                <button onClick={handleSubmit} className="btn btn-primary" type="submit">Submit</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <table className="table mt-5">
        <thead>
          <tr>
            <th scope="col">No</th>
            <th scope="col">Name</th>
            <th scope="col">Created At</th>
            <th scope="col">Updated At</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((c, index) => {

            return (
              <CategoriesTableRow c={c} index={index} key={index} />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default CategoriesTable;
